import { Effect } from "../../Materials/effect";
var name = 'depthPrePass';
var shader = "#ifdef DEPTHPREPASS\ngl_FragColor=vec4(0.,0.,0.,1.0);\nreturn;\n#endif";
Effect.IncludesShadersStore[name] = shader;
/** @hidden */

export var depthPrePass = {
  name: name,
  shader: shader
};